// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom_card[data-v-098e7fc4] {
  border: 1px solid #eee;
  border-radius: 15px;
  padding: 5px;
}
.custom_legend[data-v-098e7fc4] {
  position: absolute;
  display: inline-block;
  background: #fff;
  z-index: 9;
  font-size: 12px;
  top: -12px;
  left: 30px;
  padding: 0 6px;
  color: #000;
  opacity: 0.8;
}
.card_font_sizes h3[data-v-098e7fc4] {
  font-size: 15px;
  font-weight: 600;
  color: #000;
  white-space: initial;
  margin: 0;
}
.card_font_sizes p[data-v-098e7fc4] {
  margin-bottom: 5px;
  font-size: 12px;
  white-space: initial;
}
.min-120[data-v-098e7fc4] {
  min-height: 120px;
}
.ft-c-25[data-v-098e7fc4] {
  font-size: 30px;
}
.tvm_slide_out_service_special h3[data-v-098e7fc4] {
  font-size: 15px;
  font-weight: 600;
  color: #000;
  white-space: initial;
  margin: 0;
}
.tvm_slide_out_service_special p[data-v-098e7fc4] {
  margin-bottom: 5px;
  font-size: 12px;
  white-space: initial;
}
.tvm_slide_out_service_special table tr td[data-v-098e7fc4] {
  font-size: 10px;
  padding: 2px;
  min-width: 100px;
}
.border_seperator[data-v-098e7fc4] {
  border-bottom: 2px solid #eee;
  margin: 20px 20px;
}
.animate_bottom[data-v-098e7fc4] {
  animation: animateBottom-098e7fc4 2s;
  transition: 0.5s;
}
@keyframes animateBottom-098e7fc4 {
0% {
    transform: translateY(50px);
}
100% {
    transform: translateY(0);
}
}
@media (min-width: 1900px) {
.tvm_slide_out_service_special h3[data-v-098e7fc4] {
    font-size: 20px;
}
.tvm_slide_out_service_special p[data-v-098e7fc4] {
    font-size: 13px;
}
.tvm_slide_out_service_special table tr td[data-v-098e7fc4] {
    font-size: 12px;
}
.custom_legend[data-v-098e7fc4] {
    font-size: 13px;
}
.ft-c-25[data-v-098e7fc4] {
    font-size: 40px;
}
}
@media (min-width: 2500px) {
.tvm_slide_out_service_special h3[data-v-098e7fc4] {
    font-size: 22px;
}
.tvm_slide_out_service_special p[data-v-098e7fc4] {
    font-size: 15px;
}
.tvm_slide_out_service_special table tr td[data-v-098e7fc4] {
    font-size: 13px;
}
.custom_legend[data-v-098e7fc4] {
    font-size: 16px;
}
.ft-c-25[data-v-098e7fc4] {
    font-size: 50px;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatWidget/SlideOutPanel/TvmSlideOutServiceSpecial/TvmSlideOutServiceSpecial.vue","webpack://./TvmSlideOutServiceSpecial.vue"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,mBAAA;EACA,YAAA;ACDF;ADIA;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;ACFF;ADKA;EAEI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,SAAA;ACJJ;ADFA;EAUI,kBAAA;EACA,eAAA;EACA,oBAAA;ACLJ;ADSA;EACE,iBAAA;ACPF;ADUA;EACE,eAAA;ACRF;ADYA;EAvBI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,SAAA;ACcJ;ADKA;EAfI,kBAAA;EACA,eAAA;EACA,oBAAA;ACaJ;ADAA;EAMQ,eAAA;EACA,YAAA;EACA,gBAAA;ACHR;ADSA;EACE,6BAAA;EACA,iBAAA;ACPF;ADUA;EACE,oCAAA;EACA,gBAAA;ACRF;ADWA;AACE;IACE,2BAAA;ACTF;ADYA;IACE,wBAAA;ACVF;AACF;ADaA;AACE;IAEI,eAAA;ACZJ;ADUA;IAMI,eAAA;ACbJ;ADOA;IAYQ,eAAA;AChBR;ADsBA;IACE,eAAA;ACpBF;ADuBA;IACE,eAAA;ACrBF;AACF;ADwBA;AACE;IAEI,eAAA;ACvBJ;ADqBA;IAMI,eAAA;ACxBJ;ADkBA;IAYQ,eAAA;AC3BR;ADiCA;IACE,eAAA;AC/BF;ADkCA;IACE,eAAA;AChCF;AACF","sourcesContent":["\n// reuseable css\n.custom_card {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 5px;\n}\n\n.custom_legend {\n  position: absolute;\n  display: inline-block;\n  background: #fff;\n  z-index: 9;\n  font-size: 12px;\n  top: -12px;\n  left: 30px;\n  padding: 0 6px;\n  color: #000;\n  opacity: 0.8;\n}\n\n.card_font_sizes {\n  h3 {\n    font-size: 15px;\n    font-weight: 600;\n    color: #000;\n    white-space: initial;\n    margin: 0;\n  }\n\n  p {\n    margin-bottom: 5px;\n    font-size: 12px;\n    white-space: initial;\n  }\n}\n\n.min-120 {\n  min-height: 120px;\n}\n\n.ft-c-25 {\n  font-size: 30px;\n}\n\n// end reuseable css\n.tvm_slide_out_service_special {\n  .card_font_sizes();\n\n  table {\n    tr {\n      td {\n        font-size: 10px;\n        padding: 2px;\n        min-width: 100px;\n      }\n    }\n  }\n}\n\n.border_seperator {\n  border-bottom: 2px solid #eee;\n  margin: 20px 20px;\n}\n\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n\n@media (min-width: 1900px) {\n  .tvm_slide_out_service_special {\n    h3 {\n      font-size: 20px;\n    }\n\n    p {\n      font-size: 13px;\n    }\n\n    table {\n      tr {\n        td {\n          font-size: 12px;\n        }\n      }\n    }\n  }\n\n  .custom_legend {\n    font-size: 13px;\n  }\n\n  .ft-c-25 {\n    font-size: 40px;\n  }\n}\n\n@media (min-width: 2500px) {\n  .tvm_slide_out_service_special {\n    h3 {\n      font-size: 22px;\n    }\n\n    p {\n      font-size: 15px;\n    }\n\n    table {\n      tr {\n        td {\n          font-size: 13px;\n        }\n      }\n    }\n  }\n\n  .custom_legend {\n    font-size: 16px;\n  }\n\n  .ft-c-25 {\n    font-size: 50px;\n  }\n}\n",".custom_card {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 5px;\n}\n.custom_legend {\n  position: absolute;\n  display: inline-block;\n  background: #fff;\n  z-index: 9;\n  font-size: 12px;\n  top: -12px;\n  left: 30px;\n  padding: 0 6px;\n  color: #000;\n  opacity: 0.8;\n}\n.card_font_sizes h3 {\n  font-size: 15px;\n  font-weight: 600;\n  color: #000;\n  white-space: initial;\n  margin: 0;\n}\n.card_font_sizes p {\n  margin-bottom: 5px;\n  font-size: 12px;\n  white-space: initial;\n}\n.min-120 {\n  min-height: 120px;\n}\n.ft-c-25 {\n  font-size: 30px;\n}\n.tvm_slide_out_service_special h3 {\n  font-size: 15px;\n  font-weight: 600;\n  color: #000;\n  white-space: initial;\n  margin: 0;\n}\n.tvm_slide_out_service_special p {\n  margin-bottom: 5px;\n  font-size: 12px;\n  white-space: initial;\n}\n.tvm_slide_out_service_special table tr td {\n  font-size: 10px;\n  padding: 2px;\n  min-width: 100px;\n}\n.border_seperator {\n  border-bottom: 2px solid #eee;\n  margin: 20px 20px;\n}\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n@media (min-width: 1900px) {\n  .tvm_slide_out_service_special h3 {\n    font-size: 20px;\n  }\n  .tvm_slide_out_service_special p {\n    font-size: 13px;\n  }\n  .tvm_slide_out_service_special table tr td {\n    font-size: 12px;\n  }\n  .custom_legend {\n    font-size: 13px;\n  }\n  .ft-c-25 {\n    font-size: 40px;\n  }\n}\n@media (min-width: 2500px) {\n  .tvm_slide_out_service_special h3 {\n    font-size: 22px;\n  }\n  .tvm_slide_out_service_special p {\n    font-size: 15px;\n  }\n  .tvm_slide_out_service_special table tr td {\n    font-size: 13px;\n  }\n  .custom_legend {\n    font-size: 16px;\n  }\n  .ft-c-25 {\n    font-size: 50px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
